import { InstallLatestCommand } from './commands/install-latest.command';
import { ShellCommand } from './commands/shell.command';
import { WriteFileCommand } from './commands/writeFile.command';
import { Procedure } from './procedure.interface';
import { ProcedureFactory } from './procedures';
import { RESET_COMMANDS } from './reset';
import { MiaProperties } from '@/interfaces/properties.interface';

export const INSTALL_MIA: ProcedureFactory = (properties: unknown): Procedure => {
  // TODO: Replace typing by proper validation
  const miaProperties = properties as MiaProperties;
  const installArgsBase64 = btoa(
    `{"SenderBundleId":"${miaProperties.mia_sender_bundle_id}","TargetPUIVersion":"${miaProperties.mia_target_pui_version}","ProductSmallName":"${miaProperties.mia_product_small_name}","UserCode":"","ApiUri":"${miaProperties.mia_api_uri}","Language":"${miaProperties.mia_language}"}`,
  );
  return {
    name: 'MIA',
    resetCommands: RESET_COMMANDS,
    commands: [
      new InstallLatestCommand('UPDATER'),
      new WriteFileCommand('/sdcard/config.txt', `open_guide:0\n------\nhome_pkg:${miaProperties.mia_sender_bundle_id}\n------\n`),
      new ShellCommand('setprop persist.pxr.force.home fr.eyesoft.app,com.unity3d.player.UnityPlayerNativeActivityPico'),
      new ShellCommand(`am start -n fr.eyesoft.updater.app/com.unity3d.player.UnityPlayerActivity --es arguments "${installArgsBase64}"`),
    ],
    validationCommands: [],
  };
};
